module.exports = __webpack_public_path__ + "img/u679.9bde5f77.png";